import React, { FunctionComponent, ReactNode } from 'react';
import { Link } from 'gatsby';
import { formatLink } from '../../utils/formatLink';
import { PagePath } from '../../types/common';

type PagePathParams = Omit<PagePath, '_id' | '_key'>;

type InternalLinkV2Props = {
  reference: PagePathParams;
  children: ReactNode;
  className?: string | undefined;
  id?: string | undefined;
}

const InternalLinkV2: FunctionComponent<InternalLinkV2Props> = ({ reference, children, className, id }) => {
  let url = formatLink(reference);

  if (!url) {
    console.error('Invalid URL base:', reference);
    return <span className={className}>{children}</span>;
  }

  if (id) {
    const cleanId = id.startsWith('#') ? id.slice(1) : id;
    url += `#${cleanId}`; 
  }


  return (
    <Link
      to={url}
      className={className ? className : ""}
    >
      {children}
    </Link>
  );
}

export default InternalLinkV2;